<template>
  <div>
    <!-------------------heading------------->
    <v-row class="d-flex justify-space-between" flat>
      <v-col cols="12" md="6">
        <h1 class="heading-1">Instructor Application</h1>
      </v-col>
    </v-row>

    <div class="my-9">
      Instructor Training applications are currently handled manually when a
      trainee submits an inquiry from the
      <a
        href="http://iba-product.rootpointers.net/instructortraininginformation"
        class="primary--text"
      >
        Instructor Training webpage.</a
      >
      A more automated process may be implemented in a later phase of web
      development.
    </div>
  </div>
</template>

<script>
export default {
  name: "InstructorApplication",
};
</script>
